import React, { useMemo } from "react";
import { DashboardRow, HeadCell } from "../../types/dashboard";
import CommonTable from "../../../../../grocery/components/CommonTable";

export type BusinessType = "Laundry" | "Restaurant" | "Saloon" | "Car Wash" | "";

interface DataTableProps {
  tableRows: DashboardRow[];
  headCells: HeadCell<DashboardRow>[];
  businessType: BusinessType;
}

const DataTable: React.FC<DataTableProps> = ({ tableRows, headCells, businessType }) => {
  /**
   * Hide Outstanding column for Restaurant
   * IMPORTANT: Do NOT modify row objects
   */
  const filteredHeadCells = useMemo(() => {
    let filtered = headCells;
    
    // Hide Outstanding for Restaurant
    if (businessType === "Restaurant") {
      filtered = filtered.filter((cell) => cell.id !== "outstandingBalance");
    }
    
    // Show Parcel Fee and Tip ONLY for Restaurant
    // For other business types, hide these columns
    if (businessType !== "Restaurant") {
      filtered = filtered.filter((cell) => 
        cell.id !== "totalParcelFee" && cell.id !== "totalTip"
      );
    }
    
    return filtered;
  }, [businessType, headCells]);

  return (
    <div className="flex-[1.2] rounded-lg overflow-hidden">
      <CommonTable
        data={tableRows}
        showToolbar={false}
        headCells={filteredHeadCells}
        title="Monthly Summary" 
        pagenation={true} 
        selectable={false}
        className="w-full min-w-full"
      />
    </div>
  );
};

export default DataTable;
